<rr-start-logo routerLink="/"></rr-start-logo>
<div class="w100 col main-wrapper">
  <div class="claim gebuk">
    <div class="row">
      <span class="pad-spacer" [ngClass]="changeTextClass">{{
        shownText
      }}</span>
      &nbsp;design.
    </div>

    supercharged.
  </div>
  <div class="buttonrow row">
    <div class="start-button sans row disabled">
      <img src="images/start-arrow-left.png" alt="Pfeil nach links" />
      <span>Ecosystem Manager</span>
    </div>
    <div routerLink="/login" class="start-button sans row">
      <span>Startup Founder</span>
      <img src="images/start-arrow-right.png" alt="Pfeil nach rechts" />
    </div>
  </div>
</div>
<div class="footer sans row">
  A
  <span routerLink="/login/qwe123asd123">&nbsp;Rote Robben&nbsp;</span> Venture
  Studio Production
</div>
